module.exports = __webpack_public_path__ + "media/Icons/NoImagePinkBG-d8e3f372.svg";